import { GRAHA_NAMES, type GrahaBody } from '@astrally/shared';
import { useI18n } from '../../i18n';
import type { I18nKey } from '../../i18n';

/**
 * The nine grahas as a labelled 3×3 grid: Sanskrit name plus the one word
 * the tradition most associates with each — the karakatva in miniature.
 */

const ORDER: GrahaBody[] = [
  'sun',
  'moon',
  'mars',
  'mercury',
  'jupiter',
  'venus',
  'saturn',
  'rahu',
  'ketu',
];

const NATURE_KEY: Record<GrahaBody, I18nKey> = {
  sun: 'learn.fig.nature.sun',
  moon: 'learn.fig.nature.moon',
  mars: 'learn.fig.nature.mars',
  mercury: 'learn.fig.nature.mercury',
  jupiter: 'learn.fig.nature.jupiter',
  venus: 'learn.fig.nature.venus',
  saturn: 'learn.fig.nature.saturn',
  rahu: 'learn.fig.nature.rahu',
  ketu: 'learn.fig.nature.ketu',
};

const CELL_W = 104;
const CELL_H = 62;
const GAP = 8;

export function GrahaParivar() {
  const { t } = useI18n();
  return (
    <svg
      viewBox="0 0 328 226"
      style={{ width: '100%', height: 'auto' }}
      role="img"
      aria-label={t('learn.fig.grahaParivar.alt')}
    >
      {ORDER.map((body, i) => {
        const col = i % 3;
        const row = Math.floor(i / 3);
        const x = col * (CELL_W + GAP);
        const y = row * (CELL_H + GAP);
        // The two shadow grahas are drawn dashed: points, not bodies.
        const shadow = body === 'rahu' || body === 'ketu';
        return (
          <g key={body}>
            <rect
              x={x + 1}
              y={y + 1}
              width={CELL_W - 2}
              height={CELL_H - 2}
              rx="10"
              fill="var(--card)"
              stroke={shadow ? 'var(--mode-line)' : 'var(--border-strong)'}
              strokeWidth="1"
              strokeDasharray={shadow ? '4 3' : undefined}
            />
            <text
              x={x + CELL_W / 2}
              y={y + CELL_H / 2 - 3}
              textAnchor="middle"
              fontSize="13"
              fontWeight="700"
              fill="var(--text)"
            >
              {GRAHA_NAMES[body]}
            </text>
            <text
              x={x + CELL_W / 2}
              y={y + CELL_H / 2 + 14}
              textAnchor="middle"
              fontSize="9.5"
              fill="var(--text-dim)"
            >
              {t(NATURE_KEY[body])}
            </text>
          </g>
        );
      })}
      <text x={164} y={220} textAnchor="middle" fontSize="10" fill="var(--text-dim)">
        {t('learn.fig.grahaParivar.note')}
      </text>
    </svg>
  );
}
